/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AutogiroApprovalState } from './autogiro-approval-state';

/**
 * 
 * @export
 * @interface BackOfficeAutogiroMandateResponseDtoV4AllOf
 */
export interface BackOfficeAutogiroMandateResponseDtoV4AllOf {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {AutogiroApprovalState}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'state'?: AutogiroApprovalState;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'provider'?: BackOfficeAutogiroMandateResponseDtoV4AllOfProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'log'?: string;
    /**
     * last digit is a Luhn-algorithm control digit
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'bankAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeAutogiroMandateResponseDtoV4AllOf
     */
    'type'?: BackOfficeAutogiroMandateResponseDtoV4AllOfTypeEnum;
}

export const BackOfficeAutogiroMandateResponseDtoV4AllOfProviderEnum = {
    ATLAR: 'ATLAR',
    BILLECTA: 'BILLECTA'
} as const;

export type BackOfficeAutogiroMandateResponseDtoV4AllOfProviderEnum = typeof BackOfficeAutogiroMandateResponseDtoV4AllOfProviderEnum[keyof typeof BackOfficeAutogiroMandateResponseDtoV4AllOfProviderEnum];
export const BackOfficeAutogiroMandateResponseDtoV4AllOfTypeEnum = {
    AUTOGIRO: 'AUTOGIRO'
} as const;

export type BackOfficeAutogiroMandateResponseDtoV4AllOfTypeEnum = typeof BackOfficeAutogiroMandateResponseDtoV4AllOfTypeEnum[keyof typeof BackOfficeAutogiroMandateResponseDtoV4AllOfTypeEnum];


